import { ReviewSearchParamsDto } from '@/contracts/marketplace/reviews';
import { SortDirection } from '@/enums/sort';
import type { Sort } from '@/types/sort.type';
import { buildNextSort } from '@/components/reviews-client-page/reviews-client-page-query-actions.helpers';
import { areReviewFiltersEquivalent, normalizeReviewFilters } from '@/shared/review-filters-normalization';
import { SetStateAction } from 'react';

type UseReviewsClientPageQueryActionsArgs = {
    setSort: (sort: Sort) => void;
    setFilters: (value: SetStateAction<ReviewSearchParamsDto>) => void;
    setReviewsPage: (nextPage: number) => void;
};

export const useReviewsClientPageQueryActions = ({
    setSort,
    setFilters,
    setReviewsPage,
}: UseReviewsClientPageQueryActionsArgs) => {
    const onSortChanged = (column: string, direction?: SortDirection) => {
        setReviewsPage(1);
        setSort(buildNextSort(column, direction));
    };

    const updateFilters = (nextFilters: SetStateAction<ReviewSearchParamsDto>) => {
        let didChange = false;

        setFilters((currentFilters) => {
            const resolvedNextFilters =
                typeof nextFilters === 'function'
                    ? (nextFilters as (value: ReviewSearchParamsDto) => ReviewSearchParamsDto)(currentFilters)
                    : nextFilters;
            const normalizedNextFilters = normalizeReviewFilters(resolvedNextFilters);

            if (areReviewFiltersEquivalent(currentFilters, normalizedNextFilters)) {
                return currentFilters;
            }

            didChange = true;
            return normalizedNextFilters;
        });

        if (didChange) {
            setReviewsPage(1);
        }
    };

    const setPage = (nextPage: number) => {
        setReviewsPage(nextPage);
    };

    return {
        onSortChanged,
        updateFilters,
        setPage,
    };
};
